import React, { useState, useEffect } from 'react';

//3rd party
import moment from 'moment';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-toastify/dist/ReactToastify.css';
import { TailSpin } from  'react-loader-spinner';

//Functions
import { apiCall, apiError } from '../functions/common';

//Components
import Datepicker from './Datepicker';
import Dropdown from './Dropdown';
import DropdownGhost from './DropdownGhost';
import Button from './Button';

//Styles
import '../css/timeform.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const FormReviewHours = (props) => {
    const { t, loading: i18nLoading } = useTranslations();

    //Props
    const uren_ids = props.data.uren_ids;
    const status_id = props.data.status_id;
    const setOpenBackdrop = props.setOpenBackdrop;
    const getRegistrations= props.getRegistrations;

    const code = global.settings.api.code;

    //Variables
    const [data, setData] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [opmerking, setOpmerking] = useState('');

    //Functions

    //Submit verlofaanvraag afwijzen
    const submitForm = async () => {
        setIsUpdating(true);
        //Call API
        try {
            const response = await apiCall(`registratie/beoordelen?code=${code}&uren_ids=${JSON.stringify(uren_ids)}&status_id=${status_id}&opmerking=${opmerking}`, 'post');

            // Success
            if (response.data.success) {
                //getRegistrations();
                window.location.reload();
            }
        } catch (error) {
            // Error
            apiError(error);
        } finally {
            setIsUpdating(false);
        }
    }


    return(
        <div className="default-form">
            <h2>{t('review_hours', 'Review hours')}</h2>
            {/* Optional notes field */}
            <div className="form-field">
                <textarea
                    value={opmerking}
                    onChange={(e) => setOpmerking(e.target.value)}
                    placeholder={t('write_comment', 'Write a comment...')}
                />
            </div>

            {/* Submit form */}
            <div className="registration-submit">
                {
                    isUpdating ?
                        <TailSpin
                            height="30"
                            width="30"
                            color="#13a3f6"
                            ariaLabel="tail-spin-loading"
                            radius="1"
                            wrapperStyle={{
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            wrapperClass=""
                            visible={true}
                        />
                    :
                    <Button
                        text={t('send', 'Send')}
                        onClick={submitForm}
                    />
                }
                
            </div>
        </div>
    );
}

export default FormReviewHours;